// CashFortuneBarOverlay.jsx
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './CashFortuneBarOverlay.css';
import { flyToHeader } from './utils/flyToHeader'; // путь подправь, если utils лежит в другом месте
import { useSound } from './sfx/SoundProvider';



// 🔹 ДОБАВЬ ЭТО
const API_ORIGIN = process.env.REACT_APP_API_URL;
const API_HOST   = API_ORIGIN;

const toAbs = (p) => {
  if (!p) return null;
  if (/^https?:\/\//i.test(p)) return p;
  const rel = String(p).replace(/^\.\//, '/').replace(/^\./, '/');
  return `${API_HOST}${rel.startsWith('/') ? rel : `/${rel}`}`;
};

/* ====== маленькие inline-иконки ====== */
const TicketIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <path d="M4 7a2 2 0 0 1 2-2h8.8a1 1 0 0 1 .7.3l3.2 3.2a1 1 0 0 1 .3.7V17a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7z" fill="currentColor" opacity=".9"/>
    <path d="M8 7.5v9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity=".75"/>
  </svg>
);
const CoinIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <ellipse cx="12" cy="7" rx="7" ry="3.5" fill="currentColor" opacity=".9"/>
    <path d="M5 7v8c0 2 3 3.5 7 3.5s7-1.5 7-3.5V7" stroke="currentColor" strokeWidth="2" fill="none" opacity=".9"/>
  </svg>
);
// const SkinIcon = ({ className }) => (
//   <svg viewBox="0 0 24 24" className={className} aria-hidden>
//     <path d="M12 3l3.1 5.8 6.4.9-4.6 4.5 1.1 6.4-5.7-3-5.7 3 1.1-6.4L2.5 9.7l6.4-.9L12 3z" fill="currentColor"/>
//   </svg>
// );





const SkinIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <path d="M12 3l3.1 5.8 6.4.9-4.6 4.5 1.1 6.4-5.7-3-5.7 3 1.1-6.4L2.5 9.7l6.4-.9L12 3z" fill="currentColor"/>
  </svg>
);

// 👇 ДОБАВЬ ЭТО
// const WoodenDiceIcon = ({ className }) => (
//   <img
//     src="/uploads/quests/wooden_dice.png"
//     alt="Wooden dice"
//     className={className}
//   />
// );

const WoodenDiceIcon = ({ className }) => (
  <img
    src={toAbs('/uploads/quests/wooden_dice.png')}
    alt="Wooden dice"
    className={className}
  />
);





const EmptyIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" fill="none" opacity=".7"/>
    <path d="M8 8l8 8M16 8l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity=".7"/>
  </svg>
);
const XPIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <path d="M7 7l10 10M17 7L7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity=".9"/>
  </svg>
);





function prizeTypeForFly(seg = {}) {
  const t = (seg.type || '').toLowerCase();
  // if (t === 'cash' || t === 'coins') return 'cash';
  if (t === 'cash' || t === 'coins' || t === 'money') return 'cash';
  if (t === 'ticket')                return 'tickets';
  if (t === 'xp')                    return 'xp';
  if (t === 'skin')                  return 'skins';
  return null;
}




/* подобрать визуальную тему под приз */
function themeFor(seg = {}, translate) {
  const t = (seg.type || '').toLowerCase();
  const id = (seg.id || '').toLowerCase();
  // const skin = (seg.skin_type || '').toLowerCase();
const skin = (seg.skin_type || seg.skinType || '').toLowerCase();

  let kind = 'generic';
  let ribbon = translate('cashFortune.ribbons.prize');
  let c1 = '#5865F2', c2 = '#3B49C6', accent = '#93A1FF';
  let Icon = TicketIcon;
  let valueMain = seg.label || '';
  let valueSub = '';
  let skinTier = '';

  if (t === 'ticket') {
    kind = 'ticket';
    ribbon = translate('cashFortune.ribbons.ticket');
    c1 = '#ff7af5'; c2 = '#6a35ff'; accent = '#ffd5ff';
    Icon = TicketIcon;
    const v = seg.value ?? seg.amount;
    valueMain = v ? `$${v}` : translate('cashFortune.values.ticket');
    valueSub = translate('cashFortune.subtitles.tournamentTicket');
  // } else if (t === 'coins' || t === 'cash' || id.includes('coins')) {
  } else if (t === 'coins' || t === 'cash' || t === 'money' || id.includes('coins')) {
    kind = 'coins';
    ribbon = translate('cashFortune.ribbons.cash');
    c1 = '#30d158'; c2 = '#16b34b'; accent = '#b8ffd2';
    Icon = CoinIcon;
    const v = seg.amount ?? seg.value;
    valueMain = v ? `$${v}` : translate('cashFortune.values.cash');
    valueSub = translate('cashFortune.subtitles.balance');
  // } else if (t === 'skin') {
  //   kind = 'skin';
  //   ribbon = translate('cashFortune.ribbons.skin');
  //   Icon = SkinIcon;
  //   valueMain = seg.label || 'Скин';
  //   valueSub = skin ? `type: ${skin}` : 'украшение';
  //   skinTier = skin;

  //   const tiers = {
  //     bronze:   ['#d08a55', '#9a5e3a', '#ffe2c9'],
  //     silver:   ['#d8dee9', '#9ba8b8', '#eef6ff'],
  //     gold:     ['#f8d47c', '#cfa245', '#fff2bd'],
  //     platinum: ['#d9e5ff', '#6da7ff', '#eef5ff'],
  //     diamond:  ['#5fdcff', '#4a7dff', '#d8f3ff'],
  //     wood_dice:['#9c7a55', '#5f422e', '#f0e0cf'],
  //   };
  //   const pal = tiers[skin] || tiers.gold;
  //   [c1, c2, accent] = pal;


  } else if (t === 'skin') {
  kind = 'skin';
  ribbon = translate('cashFortune.ribbons.skin');
  Icon = SkinIcon;

  // нормализуем тип скина: skin_type или skinType
  const skin = (seg.skin_type || seg.skinType || '').toLowerCase();

  // по умолчанию – серединка
  valueMain = seg.label || translate('cashFortune.values.skin');
  valueSub = skin
    ? translate('cashFortune.subtitles.skinType', { type: skin })
    : translate('cashFortune.subtitles.decoration');
  skinTier  = skin;

  const woodPalette = ['#9c7a55', '#5f422e', '#f0e0cf'];

  const tiers = {
    bronze:       ['#d08a55', '#9a5e3a', '#ffe2c9'],
    silver:       ['#d8dee9', '#9ba8b8', '#eef6ff'],
    gold:         ['#f8d47c', '#cfa245', '#fff2bd'],
    platinum:     ['#d9e5ff', '#6da7ff', '#eef5ff'],
    diamond:      ['#5fdcff', '#4a7dff', '#d8f3ff'],
    wood_dice:    woodPalette,
    wooden_dice:  woodPalette,
  };
  const pal = tiers[skin] || tiers.gold;
  [c1, c2, accent] = pal;

  // 👇 спец-оформление именно для деревянных кубиков
  if (skin === 'wood_dice' || skin === 'wooden_dice') {
    Icon      = WoodenDiceIcon;                 // вместо звёздочки – картинка
    valueMain = translate('cashFortune.values.woodenDiceSkin'); // красивый текст
    valueSub  = '';                             // убираем "type: wood_dice"
  }




  } else if (t === 'empty') {
    kind = 'empty';
    ribbon = translate('cashFortune.ribbons.empty');
    c1 = '#3a3f52'; c2 = '#232735'; accent = '#7f879f';
    Icon = EmptyIcon;
    valueMain = translate('cashFortune.values.empty');
    valueSub = translate('cashFortune.subtitles.betterLuck');
  } else if (t === 'xp') {
    kind = 'xp';
    ribbon = 'XP';
    c1 = '#35d0ff'; c2 = '#2463ff'; accent = '#cfe7ff';
    Icon = XPIcon;
    const v = seg.amount ?? seg.value;
    valueMain = v ? `+${v} XP` : 'XP';
    valueSub = translate('cashFortune.subtitles.levelPoints');
  }

  return { kind, ribbon, c1, c2, accent, Icon, valueMain, valueSub, skinTier };
}

/**
 * Непрерывная синхронная прокрутка 5 слотов по дуге (вперёд, без «обратки»).
 * Победитель — ярко подсвечен, маркера-треугольника нет.
 */
export default function CashFortuneBarOverlay({
  show = true,
  title = null,
  segments = [],
  selectedId = null,
  selectedIndex = null, 

  visibleCount = 5,
  edgesHalfVisible = true,
  useAutoRotation = true,

  gap = 12,
  aspect = 0.58,
  size = 0.95,
  sagittaPct = 0.52,
  topOffset = -240,
  viewportHeight = 320,

  layoutLtr = [
    { dx: 50,  dy: 680, rot: 30 },
    { dx: -50, dy: 110, rot: -2 },
    { dx: -10, dy: -70, upright: true },
    { dx: 30,  dy: 80,  rot: 4 },
    { dx: -50, dy: 630, rot: 330 },
  ],

  loops = 3,
  spinDurationMs = 4000,

  onHide,
  onCollect = () => {},          // 🔧 добавили проп по умолчанию
}) {
  const wrapRef = useRef(null);
  const rafRef  = useRef(0);
  const [vw, setVW] = useState(typeof window !== 'undefined' ? window.innerWidth : 1280);
  const vh = viewportHeight;

  const [showCta, setShowCta] = useState(false);
  const { play } = useSound();
  const { t: translate } = useTranslation();
  const clickedRef = useRef(false); // защита от двойного клика
  /* базовые размеры */
  const totalGaps = (visibleCount - 1) * gap;
  const CARD_W = useMemo(() => {
    const base = Math.floor((vw - totalGaps) / visibleCount);
    return Math.max(140, Math.floor(base * size));
  }, [vw, totalGaps, visibleCount, size]);
  const CARD_H = useMemo(() => Math.floor(CARD_W / aspect), [CARD_W, aspect]);
  const SLOT_W = CARD_W + gap;

  const rowWidth       = CARD_W * visibleCount + totalGaps;
  const rowLeftPadding = Math.max(0, Math.floor((vw - rowWidth) / 2));
  const centerSlot     = Math.floor(visibleCount / 2);
  const viewportCenterX= rowLeftPadding + Math.floor(rowWidth / 2);

  // const winnerSeg = useMemo(
  //   () => segments.find(s => s.id === selectedId) || null,
  //   [segments, selectedId]
  // );
  const winnerSeg = useMemo(
  () => segments.find(s => String(s?.id) === String(selectedId)) || null,
  [segments, selectedId]
);
 
  const isEmptyPrize = useMemo(() => {
    const type = String(winnerSeg?.type || '').toLowerCase();
    const label = String(winnerSeg?.label || '').trim().toLowerCase();
    const emptyLabels = [
      'пусто',
      'empty',
      'vide',
      'vuoto',
      'boş',
      'ცარიელია',
      'դատարկ',
      String(translate('cashFortune.values.empty')).toLowerCase(),
    ];

    return type === 'empty' || emptyLabels.some((item) => label.includes(item));
  }, [winnerSeg, translate]);

  const resolvedTitle = useMemo(() => {
    const raw = String(title || '').trim();
    const normalized = raw.toLowerCase();
    const defaultTitles = [
      '',
      'ваш приз',
      'your prize',
      'votre gain',
      'il tuo premio',
      'თქვენი პრიზი',
      'ձեր մրցանակը',
      'mükafatınız',
    ];

    return defaultTitles.includes(normalized)
      ? translate('cashFortune.title')
      : raw;
  }, [title, translate]);

  /* дуга */
  const geom = useMemo(() => {
    const W = Math.max(600, vw);
    const s = Math.min(Math.round(W * sagittaPct), Math.round(CARD_H * 0.98));
    const R = (W * W) / (8 * s) + s / 2;
    const cx = W / 2;
    const yOfX = (x) => {
      const d = x - cx;
      const under = Math.max(0, R * R - d * d);
      return s - (R - Math.sqrt(under));
    };
    const angleDeg = (x) => {
      const d = x - cx;
      const denom = Math.max(1e-6, Math.sqrt(Math.max(0, R * R - d * d)));
      return (Math.atan(d / denom) * 180) / Math.PI;
    };
    return { yOfX, angleDeg, s, W };
  }, [vw, CARD_H, sagittaPct]);

  const baseY = useMemo(() => {
    return Math.round(vh * 0.06) - Math.round(CARD_H * 0.72) + topOffset;
  }, [vh, CARD_H, topOffset]);

  useLayoutEffect(() => {
    if (!show) return;
    const onR = () => setVW(window.innerWidth);
    onR();
    window.addEventListener('resize', onR);
    return () => window.removeEventListener('resize', onR);
  }, [show]);

  /* хелперы */
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const lerp  = (a, b, t) => a + (b - a) * t;
  const normAngle = (deg) => {
    let d = deg;
    while (d > 180) d -= 360;
    while (d < -180) d += 360;
    return d;
  };
  const lerpAngle = (a, b, t) => {
    const aN = normAngle(a);
    const bN = normAngle(b);
    let diff = bN - aN;
    if (diff > 180) diff -= 360;
    if (diff < -180) diff += 360;
    return normAngle(aN + diff * t);
  };
  const smoothstep = (x) => x <= 0 ? 0 : x >= 1 ? 1 : (3*x*x - 2*x*x*x);

  /* куда остановиться (по слотам) */
const selectedIdx = useMemo(() => {
    const N = Math.max(1, segments.length);
    // 1) если пришёл индекс — верим индексу
    if (Number.isInteger(selectedIndex) && selectedIndex >= 0 && selectedIndex < N) {
      return selectedIndex;
    }
    // 2) иначе пытаемся по id
    if (segments?.length && selectedId != null) {
      const i = segments.findIndex(s => String(s?.id) === String(selectedId));
      if (i >= 0) return i;
    }
    // 3) безопасный дефолт
    return 0;
  }, [segments, selectedId, selectedIndex]);

  const sTarget = useMemo(() => {
    const N = Math.max(1, segments.length);
    const base = (selectedIdx - centerSlot) % N;
    const basePos = (base + N) % N;
    return loops * N + basePos;
  }, [segments.length, selectedIdx, centerSlot, loops]);

  /* анимация — непрерывно вперёд */
  const [sOffset, setSOffset] = useState(0);






    useEffect(() => {
    // если оверлей не показан или нет данных — выходим
    if (!show || !segments?.length || !selectedId) return;

    // если вдруг используешь этот компонент без авто-вращения — звук тоже не нужен
    if (!useAutoRotation) return;

    // при новом запуске спина скрываем кнопку и запускаем звук
    setShowCta(false);

    // 🎵 запускаем звук карточек
    play('cardGame').catch(() => {});

    cancelAnimationFrame(rafRef.current);
    let start = 0;
    const dur = Math.max(800, spinDurationMs);

    const run = (ts) => {
      if (!start) start = ts;
      const t = clamp((ts - start) / dur, 0, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setSOffset(sTarget * eased);
      if (t < 1) {
        rafRef.current = requestAnimationFrame(run);
      } else {
        setSOffset(sTarget);
      }
    };

    rafRef.current = requestAnimationFrame(run);
    return () => cancelAnimationFrame(rafRef.current);
  }, [show, segments, selectedId, sTarget, spinDurationMs, useAutoRotation, play]);


  // useEffect(() => {
  //   if (!show || !segments?.length || !selectedId) return;
  //   // прячем CTA при новом запуске
  //   setShowCta(false);

  //   cancelAnimationFrame(rafRef.current);
  //   let start = 0;
  //   const dur = Math.max(800, spinDurationMs);

  //   const run = (ts) => {
  //     if (!start) start = ts;
  //     const t = clamp((ts - start) / dur, 0, 1);
  //     const eased = 1 - Math.pow(1 - t, 3);
  //     setSOffset(sTarget * eased);
  //     if (t < 1) rafRef.current = requestAnimationFrame(run);
  //     else setSOffset(sTarget);
  //   };
  //   rafRef.current = requestAnimationFrame(run);
  //   return () => cancelAnimationFrame(rafRef.current);
  // }, [show, segments, selectedId, sTarget, spinDurationMs]);

  /* текущий состав окна (+1 слева +1 справа) */
  const S    = Math.floor(sOffset);
  const frac = sOffset - S;

  const kStart = -1;
  const total  = visibleCount + 2;

  const visible = Array.from({ length: total }, (_, m) => {
    const k = kStart + m;
    const N = Math.max(1, segments.length);
    const seg = segments[(S + k + N * 1000) % N] || { id: `placeholder-${m}`, label: '' };
    const pos = k - frac;
    return { seg, pos, k };
  });

  const poseAt = (pos) => {
    const i0 = Math.max(0, Math.min(visibleCount - 1, Math.floor(pos)));
    const i1 = Math.max(0, Math.min(visibleCount - 1, i0 + 1));
    const t  = Math.max(0, Math.min(1, pos - i0));

    const a = layoutLtr[i0] || {};
    const b = layoutLtr[i1] || {};

    let dx = lerp(Number(a.dx || 0), Number(b.dx || 0), t);
    let dy = lerp(Number(a.dy || 0), Number(b.dy || 0), t);

    const leftBase = rowLeftPadding + pos * (CARD_W + gap);

    // аккуратные «полкарты» без обратки
    let edgeAdj = 0;
    if (edgesHalfVisible) {
      const tL = smoothstep(Math.max(0, Math.min(1, (0.6 - pos) / 0.6)));
      const tR = smoothstep(Math.max(0, Math.min(1, (pos - ((visibleCount - 1) - 0.6)) / 0.6)));
      edgeAdj += -(CARD_W / 2) * tL + (CARD_W / 2) * tR;
    }

    const left    = leftBase + dx + edgeAdj;
    const centerX = left + CARD_W / 2;

    const rotAuto = useAutoRotation ? geom.angleDeg(centerX) : 0;
    const addRot0 = (a.upright ? -rotAuto : Number(a.rot || 0));
    const addRot1 = (b.upright ? -rotAuto : Number(b.rot || 0));
    const addRot  = lerpAngle(addRot0, addRot1, t);
    const rot     = rotAuto + addRot;

    const yArc = geom.yOfX(centerX);
    const top  = baseY + yArc + dy;

    return { left, top, rot, centerX };
  };

  const trackHeight = Math.max(vh, CARD_H + geom.s + 80);
  const finished    = Math.abs(sOffset - sTarget) < 1e-3;
  const viewportCx  = viewportCenterX;

  // показываем CTA, когда закончено
  useEffect(() => {
    if (finished) setShowCta(true);
  }, [finished]);

  if (!show) return null;

  return (
    <div className="arc-overlay" role="dialog" aria-modal>
      <div className="arc-card">
        <div className="arc-title">{resolvedTitle}</div>

        <div className="arc-viewport" ref={wrapRef} style={{ height: viewportHeight }}>
          <div className="arc-track" style={{ width: vw, height: trackHeight }}>
            {visible.map(({ seg, pos, k }) => {
              const { left, top, rot, centerX } = poseAt(pos);
              const theme = themeFor(seg, translate);
              const isCenterNow = Math.abs(centerX - viewportCx) < (SLOT_W * 0.18);
              const isSelected  = finished && isCenterNow && selectedId && seg.id === selectedId;

              const Icon = theme.Icon;

              return (
                <div
                  key={`${seg.id}-${k}-${S}`}
                  className={
                    `arc-seg theme--${theme.kind}` +
                    (theme.skinTier ? ` skin-tier--${theme.skinTier}` : '') +
                    (isSelected ? ' is-selected' : '')
                  }
                  style={{
                    '--c1': theme.c1,
                    '--c2': theme.c2,
                    '--accent': theme.accent,
                    left, top, transform: `rotate(${rot}deg)`
                  }}
                >
                  <div className="arc-seg__chrome" />
                  <div className="arc-seg__ribbon">{theme.ribbon}</div>

                  <div className="arc-seg__content">
                    <Icon className="arc-seg__icon" />
                    <div className="arc-seg__value">{theme.valueMain}</div>
                    {theme.valueSub ? <div className="arc-seg__sub">{theme.valueSub}</div> : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA один раз, под треком */}
        {showCta && (
          <div className="arc-cta">
          <button
   type="button"
   className={`arc-btn ${isEmptyPrize ? 'is-ghost' : ''}`}



onClick={async (e) => {
  if (clickedRef.current) return;
  clickedRef.current = true;

  // звуки/анимации
  (isEmptyPrize ? play('cancel') : play('registerTournament')).catch(() => {});
  if (!isEmptyPrize && winnerSeg) {
    play('questBonus').catch(() => {});
    const type = prizeTypeForFly(winnerSeg);
    if (type) {
      const amount = Number(winnerSeg.amount ?? winnerSeg.value ?? 1);
      const count  = type === 'cash'
        ? Math.min(10, Math.max(6, Math.round(Math.sqrt(amount)) + 3))
        : 6;
      flyToHeader({ type, sourceEl: e.currentTarget, countVisual: count });
    }
  }

  try {
    // ✅ всегда сообщаем наверх исход спина (даже если «Пусто»)
    await onCollect({
      winner: winnerSeg ?? null,
      isWin: !isEmptyPrize,
    });
  } finally {
    // 🔔 скажем приложению «освежи турниры/столы»
    // window.dispatchEvent(new CustomEvent('tournaments-refresh'));
    setTimeout(() => {
     window.dispatchEvent(new CustomEvent('tournaments-refresh'));
   }, 400);
    onHide?.();                // закрыть модалку
    setTimeout(() => { clickedRef.current = false; }, 800);
  }
}}




>
              {isEmptyPrize
                ? translate('cashFortune.buttons.close')
                : translate('cashFortune.buttons.collect')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}


// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import '../src/CashFortuneBarOverlay.css'


// export default function CashFortuneBarOverlay({
//   show,
//   segments = [],
//   selectedId,
//   onHide,
//   title = null,
// }) {
//   const containerRef = useRef(null);
//   const trackRef = useRef(null);
//   const [animReady, setAnimReady] = useState(false);
//   const [done, setDone] = useState(false);
//   const [reveal, setReveal] = useState(false);



//   // Дублируем сегменты, чтобы была «дорожка» под прокрутку
//   const SEG_W = 140; // px — ширина одного сектора (должна совпадать с CSS)
//   const DURATION_MS = 10000; // 10 секунд
//   const LOOPS = 6;          // сколько «кругов» прокрутим визуально
// // рендерим много копий, чтобы был длинный путь прокрутки
// const renderSegments = useMemo(() => {
//   if (!Array.isArray(segments) || segments.length === 0) return [];
//   const REPEATS = Math.max(3 + LOOPS, 5); // минимально 5 копий
//   const arr = [];
//   for (let r = 0; r < REPEATS; r++) {
//     for (const s of segments) arr.push(s);
//   }
//   return arr;
// }, [segments]);

// // целимся в «предпоследнюю» копию, чтобы путь был длинный
// const targetIndexInRender = useMemo(() => {
//   if (!segments.length || !selectedId) return 0;
//   const base = segments.findIndex(s => s.id === selectedId);
//   const safeBase = base < 0 ? 0 : base;

//   const REPEATS = Math.max(3 + LOOPS, 5);
//   // предпоследняя копия: REPEATS - 2
//   return safeBase + segments.length * (REPEATS - 2);
// }, [segments, selectedId]);





// // когда прячем оверлей — на следующий показ подсветка снова будет скрыта
// useEffect(() => {
//   if (!show) setReveal(false);
// }, [show]);

//   // вычисляем конечный translateX так, чтобы выбранный сегмент оказался по центру контейнера
// useEffect(() => {
//   if (!show || !trackRef.current || !containerRef.current) return;
//   if (!renderSegments.length) return;

//   const container = containerRef.current;
//   const track = trackRef.current;

//   // прячем подсветку до фактической остановки
//   setReveal(false);
//   setAnimReady(false);

//   // 1) сброс без анимации
//   track.style.transition = 'none';
//   track.style.transform = 'translate3d(0px,0,0)';

//   // форс-рефлоу, чтобы следующий transition точно сработал
//   // (иначе браузер может склеить два состояния)
//   void track.offsetHeight;

//   // 2) кадр спустя — запускаем анимацию к целевой позиции
//   const rafId = requestAnimationFrame(() => {
//     const containerW = container.getBoundingClientRect().width;
//     const targetCenter = targetIndexInRender * SEG_W + SEG_W / 2;
//     const targetX = -(targetCenter - containerW / 2);

//     // плавное ускорение/замедление на 10s
//     track.style.transition = `transform ${DURATION_MS}ms cubic-bezier(0.08, 0.7, 0, 1)`;
//     track.style.transform = `translate3d(${targetX}px,0,0)`;

//     setAnimReady(true);
//   });

//   // 3) подсвечиваем только после окончания движения
//   const onEnd = () => setReveal(true);
//   track.addEventListener('transitionend', onEnd, { once: true });

//   // страховка, если почему-то не придёт transitionend
//   const safetyTimer = setTimeout(onEnd, DURATION_MS + 150);

//   // cleanup
//   return () => {
//     cancelAnimationFrame(rafId);
//     track.removeEventListener('transitionend', onEnd);
//     clearTimeout(safetyTimer);
//   };
// }, [show, renderSegments.length, targetIndexInRender]);


//   // финал анимации
//   const handleEnd = () => {
//     setDone(true);
//     // чуток подержим приз, потом закроемся
//     setTimeout(() => {
//       setAnimReady(false);
//       setDone(false);
//       onHide?.();
//     }, 1400);
//   };

//   if (!show) return null;

//   const selected = segments.find(s => s.id === selectedId);

//   return (
//     <div className="cfb-overlay" role="dialog" aria-modal>
//       <div className="cfb-card">
//         <div className="cfb-title">{title}</div>

//         <div className="cfb-viewport" ref={containerRef}>
//           {/* маркер центра */}
//           <div className="cfb-marker" aria-hidden />
//           <div className="cfb-track" ref={trackRef} onTransitionEnd={handleEnd}>
//             {renderSegments.map((seg, i) => (
//               <div
//                 key={`${seg.id}-${i}`}
//                 className={'cfb-seg' + (reveal && i === targetIndexInRender ? ' is-target' : '')}
//                 style={{ width: SEG_W }}
//                 >
//                 <div className="cfb-seg__label">{seg.label}</div>
//                 {seg.badge ? <div className="cfb-seg__badge">{seg.badge}</div> : null}
//                 </div>
//             ))}
//           </div>
//         </div>

//         <div className={'cfb-result' + (done ? ' is-visible' : '')}>
//           {selected ? prettyPrize(selected) : 'Подарок!'}
//         </div>

//         <button className="cfb-close" onClick={onHide} disabled={!animReady}>
//           Закрыть
//         </button>
//       </div>
//     </div>
//   );
// }

// function prettyPrize(sel) {
//   // ожидаем, что сервер уже выдал selected {segmentId, value, currency?} и сегмент label красивый,
//   // но на всякий форматируем если надо
//   if (sel.value && sel.currency) return `+${sel.value} ${sel.currency}`;
//   if (sel.value && !sel.currency) return `+${sel.value}`;
//   return sel.label || 'Приз';
// }
